import { makeStyles } from '@material-ui/core';

export const useCompleteBRCInscriptionStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  description: {
    color: '#ababab',
    fontSize: '14px',
    lineHeight: '22px',
    margin: '8px 0 0',
  },
  imageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px',
    borderRadius: '8px',
    border: '1px solid #E7E7E9',
    background: '#FFFFFF',
  },
  qrcode: {
    display: 'grid',
    justifyItems: 'center',
    alignItems: 'end',
    gap: '16px',
    [theme.breakpoints.down('xs')]: {
      gap: '16px',
    },
  },
  copyCode: {
    display: 'flex',
    padding: '8px 16px',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    borderRadius: '8px',
    maxWidth: '492px',
    width: '100%',
    background: 'var(--color-white-3)',
    border: 'border: 0.5px solid var(--color-black-4)',
    '& > p': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: '14px',
      lineHeight: '20px',
      color: '#FAFAFA',
      [theme.breakpoints.down('xs')]: {
        width: '250px',
      },
      [theme.breakpoints.down(330)]: {
        width: '170px',
      },
    },
  },
  descriptionTotal: {
    display: 'flex',
    flexDirection: 'column',
    margin: '32px 0',
    gap: '16px',
    [theme.breakpoints.down('xs')]: {
      margin: '16px 0',
    },
  },
  total: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > p:nth-child(1)': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: '14px',
      lineHeight: '20px',
      color: '#ABABAB',
      [theme.breakpoints.down('xs')]: {
        width: 'unset',
        whiteSpace: 'nowrap',
      },
    },
  },
  copyCodeTotal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '8px 0px',
    borderRadius: '8px',
    maxWidth: '350px',
    '&>p': {
      fontSize: 14,
      fontWeight: 500,
      color: '#fafafa',
      [theme.breakpoints.down('xs')]: {
        wordBreak: 'break-all',
        fontSize: 12,
      },
    },
  },
  copyBTC: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 0px',
    borderRadius: '8px',
    maxWidth: '348px',
    '& > p': {
      display: 'flex',
      justifyContent: 'center',
      fontSize: '24px',
      color: '#FFFFFF',
      [theme.breakpoints.down('xs')]: {
        width: '250px',
      },
    },
  },
  powered: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '0px',
    opacity: '0.2',
    textTransform: 'uppercase',
    marginBottom: '10px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '4px',
      marginBottom: '10px',
    },
  },

  tableType: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '32px',
    borderBottom: '1px solid #ABABAB',
    [theme.breakpoints.down('md')]: {
      padding: '0px 16px',
      width: '100%',
      overflowX: 'scroll',
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: '16px',
      background: '#1f2023',
      padding: '0 16px',
      width: '100%',
      overflowX: 'scroll',
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },

    '& > div': {
      fontWeight: 500,
      padding: '0 10px 16px 10px',
      fontSize: '14px',
      whiteSpace: 'nowrap',
      lineHeight: '20px',
      color: '#949494',
      marginRight: '16px',
      alignContent: 'center',
      cursor: 'pointer',
      [theme.breakpoints.down('xs')]: {},

      '&.selected': {
        cursor: 'pointer',
        borderBottom: '3px solid #FAFAFA',
        background: 'none',
        color: '#fff',
      },
      '&:hover': {
        color: '#fff',
      },
    },
  },
  dollarAmount: {
    color: '#fafafa',
    fontSize: '12px',
    fontWeight: 500,
    opacity: 0.7,
    marginRight: 5,
  },
  totalFee: {
    display: 'flex',
    aligItems: 'center',
  },
  tableTypeTiles: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      padding: '0px 16px',
      width: '100%',
      overflowX: 'scroll',
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: '16px',
      background: '#1f2023',
      padding: '0 16px',
      width: '100%',
      overflowX: 'scroll',
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },

    '& > div': {
      fontWeight: 500,
      padding: '0 10px 16px 10px',
      fontSize: '14px',
      whiteSpace: 'nowrap',
      lineHeight: '20px',
      color: '#949494',
      marginRight: '16px',
      alignContent: 'center',
      cursor: 'pointer',
      [theme.breakpoints.down('xs')]: {},

      '&.selected': {
        cursor: 'pointer',
        borderBottom: '3px solid #FAFAFA',
        background: 'none',
        color: '#fff',
      },
      '&:hover': {
        color: '#fff',
      },
    },
  },
  multiWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
  },
  tokenBalanceWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  tokenBalance: {
    display: 'flex',
    justifyContent: 'space-between',
    '& > p:nth-child(1)': {
      color: '#FFFFFF',
    },
  },
  btn: {
    display: 'flex',
    width: '100%',
    height: '48px',
    padding: '13px 16px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0px',
    borderRadius: '6px',
    background: '#F09242',
    color: '#FFFFFF',
    cursor: 'pointer',
  },
  tilesWrap: { display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: 16 },
  tiles: {
    display: 'flex',
    width: '100%',
    padding: '12px 16px',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '4px',
    borderRadius: '8px',
    border: '1px solid var(--750, #292A2F)',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'var(--750, #292A2F)',
    },
  },
  rate: {
    display: 'flex',
    flexDirection: 'column',
    '& > p:nth-child(1)': {
      color: '#FFFFFF',
    },
  },

  price: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    '& > p:nth-child(1)': {
      color: '#FFFFFF',
    },
    '& > p': {
      display: 'flex',
      justifyContent: 'end',
    },
  },
  buttonsWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
  },
  feeRate: {},
  addToMultiTxnWrap: {},
  modalTitle: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    marginBottom: '10px',
    marginTop: -32,
    maxWidth: '90%',
  },
  titleContent: {
    color: '#FAFAFA',
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '32px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
      lineHeight: '24px',
    },
  },
  cursorUnset: {
    cursor: 'unset',
  },
}));
